(ns ballot-scout-v2-frontend.voter-lookup.subs
  (:require
   [ballot-scout-v2-frontend.voter-lookup.common :refer [ns-key get-cached-args]]
   [clojure.string :as str]
   [medley.core :refer [distinct-by]]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::response
 (fn [db]
   (get-in db [ns-key :response])))

(rf/reg-sub
 ::searched?
 (fn [db]
   (get-in db [ns-key :searched?])))

(rf/reg-sub
 ::export
 (fn [db]
   (get-in db [ns-key :export])))

(rf/reg-sub
 ::args
 (fn [db]
   (get-cached-args db)))

(rf/reg-sub
 ::ballot-history-response
 (fn [db]
   (:ballot-history-response db)))

(rf/reg-sub
 ::show-ballot-history
 (fn [db]
   (:show-ballot-history db)))

;; TODO: consider DRYing this up somehow
(defn hide-vb-in-transits-before-mailed
  "hides all in-transits that occur before or have the same timestamp as mailed"
  [events]
  (let [vb-mailed-ts (:ts (first (filter #(= (:resolved-status %) "voter-bound/mailed") events)))
        hide-these #{"voter-bound/in-transit" "voter-bound/out-for-delivery"}]
    (if (nil? vb-mailed-ts)
      events
      (filter #(or (not (contains? hide-these (:resolved-status %)))
                   (> (:ts %) vb-mailed-ts)) events))))

(defn hide-vb-after-delivered
  "hides all in-transits that occur after or have the same timestamp as delivered"
  [events]
  (let [vb-delivered-ts (:ts (first (filter #(= (:resolved-status %) "voter-bound/delivered") events)))
        hide-these #{"voter-bound/in-transit" "voter-bound/mailed" "voter-bound/out-for-delivery"}]
    (if (nil? vb-delivered-ts)
      events
      (filter #(or (not (contains? hide-these (:resolved-status %)))
                   (< (:ts %) vb-delivered-ts)) events))))

(defn hide-ob-in-transits-before-mailed
  "hides all in-transits that occur before or have the same timestamp as mailed"
  [events]
  (let [ob-mailed (first (filter #(= (:resolved-status %) "office-bound/mailed") events))
        ob-mailed-ts (:ts ob-mailed)
        hide-these #{"office-bound/in-transit" "office-bound/out-for-delivery"}]
    (if (nil? ob-mailed-ts)
      events
      (filter #(or (not (contains? hide-these (:resolved-status %)))
                   (> (:ts %) ob-mailed-ts)) events))))

(defn hide-ob-after-delivered
  "hides all in-transits that occur after or have the same timestamp as delivered"
  [events]
  (let [ob-delivered-ts (:ts (first (filter #(= (:resolved-status %) "office-bound/delivered") events)))
        hide-these #{"office-bound/in-transit" "office-bound/mailed" "office-bound/out-for-delivery"}]
    (if (nil? ob-delivered-ts)
      events
      (filter #(or (not (contains? hide-these (:resolved-status %)))
                   (< (:ts %) ob-delivered-ts)) events))))

(defn mark-updated-edds [events]
  (let [same-dates (partition-by :estimated-delivery-date events)
        non-null-edd (filter :estimated-delivery-date events)
        initial-vb-edd (->> non-null-edd (filter #(clojure.string/includes? (str (:resolved-status %)) "voter-bound")) first :estimated-delivery-date)
        initial-ob-edd (->> non-null-edd (filter #(clojure.string/includes? (str (:resolved-status %)) "office-bound")) first :estimated-delivery-date)]
    (flatten
     (concat
      (map #(assoc % :updated-edd (not (contains? #{nil initial-vb-edd initial-ob-edd} (:estimated-delivery-date %)))) (map first same-dates))
      (map rest same-dates)))))

(def logical-ordering  {"disposition/mailed" 1
                        "voter-bound/mailed" 3
                        "voter-bound/in-transit" 3
                        "voter-bound/delivered" 3
                        "voter-bound/returned" 3
                        "office-bound/mailed" 4
                        "office-bound/in-transit" 4
                        "office-bound/out-for-delivery" 4
                        "office-bound/delivered" 4
                        "office-bound/returned" 4
                        "disposition/received" 9
                        "disposition/accepted" 9
                        "disposition/flagged" 9})

(defn event-comparator
  "Comparator that sorts by logical order, then by date (and time if exists)"
  [a b]
  ; if they each are in the map, then return the boolean
  (if (and (> (logical-ordering (:resolved-status a)) 0)
           (> (logical-ordering (:resolved-status b)) 0))
    ; if the status is the same, then sort by date/time
    (cond (= (logical-ordering (:resolved-status a)) (logical-ordering (:resolved-status b)))
          (< (:ts a) (:ts b))
          :else
          (< (logical-ordering (:resolved-status a)) (logical-ordering (:resolved-status b))))
    ; if the status is not listed for any reason, then sort by date/time
    (< (:ts a) (:ts b))))

(rf/reg-sub
 ::event-data
 :<- [::ballot-history-response]
 (fn [ballot-history]
   (when (map? ballot-history)
     (->> ballot-history
          :ballot/all-events
          (concat [{:resolved-status :disposition/created}]) ; concats the created event to the beginning of these events
          hide-vb-after-delivered
          hide-vb-in-transits-before-mailed
          hide-ob-after-delivered
          hide-ob-in-transits-before-mailed
          mark-updated-edds
          (distinct-by :ts) ; remove events with identical timestamp
          (sort event-comparator)))))
